import _ from "lodash";
import { DDI_OPTIONS } from "../shared/constants/ddi.constants";
import { StringUtils } from "../utils/string.utils";
import { Entity } from "./Entity.abstract";
import { RatingEntity } from "./RatingEntity";

export class CompanyContact extends Entity {
    currentDdi = DDI_OPTIONS[0];
    phone = "";
    fullWhatsappPhoneNumber = "";
    constructor({
        _id,
        email,
        name,
        relations,
        rating,
        type,
        whatsapp,
        accountingId,
        companyId,
        company,
        viewModel,
        consentWhatsapp
    } = {}) {
        super({
            _id,
            email,
            name,
            relations,
            rating,
            type,
            accountingId,
            companyId,
            company,
            whatsapp,
            viewModel,
            consentWhatsapp
        });
        this.setCompanyName();
        this.setRatingEntity();
    }

    static restore({
        _id,
        email,
        name,
        relations,
        rating,
        type,
        accountingId,
        companyId,
        company,
        whatsapp,
        viewModel,
        consentWhatsapp
    } = {}) {
        const entity = new CompanyContact({
            _id,
            email,
            name,
            relations,
            whatsapp,
            rating,
            type,
            accountingId,
            companyId,
            company,
            viewModel,
            consentWhatsapp
        });

        if (entity?.props?.whatsapp === "undefined") {
            entity.props.whatsapp = "";
        }

        entity.setWhatsappWithDDI();
        return entity;
    }

    setCompanyName() {
        if (this.props.type === "others")
            this.props.company = this.getCompanyId();
    }

    setWhatsapp() {
        if (this.phone) {
            this.props.whatsapp = `${this.currentDdi.value}:${this.phone}`;
        }
    }

    setWhatsappWithDDI() {
        if (!this.props.whatsapp) return;

        this.props.whatsapp = String(this.props?.whatsapp);
        if (!this.props?.whatsapp?.includes(":")) {
            this.props.whatsapp = `55:${this.props.whatsapp}`;
            this.phone = this.props.whatsapp;
        }

        const [currentDDi, phone] = this.props.whatsapp.split(":");

        const phoneDdi = DDI_OPTIONS.find((w) => w.value === currentDDi);
        if (!phoneDdi) return;
        this.currentDdi = phoneDdi;
        this.phone = phone;

        if (!currentDDi) {
            this.props.whatsapp = `${this.currentDdi.value}:${this.props.whatsapp}`;
        } else if (currentDDi !== this.currentDdi.value) {
            this.props.whatsapp = `${this.currentDdi.value}:${phone}`;
        }
    }

    setRatingEntity() {
        if (this.props.rating)
            this.props.rating = new RatingEntity(this.props.rating);
    }

    getCompanyId() {
        return this.props.companyId;
    }

    setId(_id) {
        this.props._id = _id;
    }

    emailToLowerCase() {
        if (!this.props.email) return;

        this.props.email = this.props.email.toLowerCase();
    }

    parseAccessData(data) {
        this.props.contactData = {
            companyId: data.companyId,
            _id: data._id,
            username: data.email,
            email: data.email,
            profile: {
                accountingId: data.accountingId,
                name: data.name,
                email: data.email,
                companyIds: []
            }
        };
    }

    setContact({ contact, report, accountingId }) {
        this.props = {
            accountingId: accountingId,
            companyId: report.companyId,
            email: contact.email,
            name: contact.name,
            _id: contact._id
        };
    }

    transformRelations() {
        const relations = Object.keys(this.props.relations);
        relations.map((key) => {
            this.props.relations[key].status = Number(
                this.props.relations[key].status || false
            );
        });
    }

    transformRelationsToBool() {
        const relations = Object.keys(this.props.relations);
        relations.map((key) => {
            this.props.relations[key].status = Boolean(
                this.props.relations[key].status
            );
        });
    }

    hasRelationUserActive() {
        return this.props.relations?.user?.status;
    }

    getActivationLink(accountingId) {
        if (!accountingId || !this.props.relations?.user?._id)
            return `${publicSettings.url}`;
        return `${publicSettings.url}/ativacao-usuario/${accountingId}/${this.props.relations?.user?._id}`;
    }

    toggleRelationStatus(path) {
        _.set(
            this.props,
            `relations.${path}`,
            !_.get(this.props, `relations.${path}`)
        );
    }

    setRelationStatus(path, status) {
        _.set(this.props, `relations.${path}`, status);
    }

    isRatingScoreType(whichType) {
        if (!this.props.rating) return undefined;
        return this.props.rating.isScoreType(whichType);
    }

    receivedRating() {
        if (!this.props.rating) return undefined;
        return this.props.rating.received();
    }

    answeredRating() {
        if (!this.props.rating) return undefined;
        return this.props.rating.answered();
    }

    notSentRating() {
        if (!this.props.rating) return true;
        return this.props.rating.notSent();
    }

    getRatingId() {
        if (!this.props.rating) return undefined;
        return this.props.rating.getId();
    }

    createFirstRating() {
        this.props.rating = new RatingEntity({
            accountingId: this.props.accountingId,
            companyId: this.props.companyId,
            name: this.props.name,
            email: this.props.email,
            events: { sent: new Date() }
        });
    }

    setDDiWhatsapp(ddi) {
        const [currentDDi, phone] = ddi.split(":");
        if (!currentDDi) {
            this.props.whatsapp = `${ddi}:${this.props.whatsapp}`;
        } else if (currentDDi !== ddi) {
            this.props.whatsapp = `${ddi}:${phone}`;
        }
    }

    getMaskWhatsapp() {
        if (!this?.props?.whatsapp) {
            const formatddi = DDI_OPTIONS[0];
            return `${
                formatddi?.label.replace(
                    formatddi.value,
                    "0".repeat(formatddi.value.length)
                ) || "+00"
            } ${formatddi.mask}`;
        }
        let formatddi = DDI_OPTIONS.find((d) =>
            String(this?.props?.whatsapp).includes(d.value)
        );
        if (!formatddi) {
            formatddi = DDI_OPTIONS[0];
        }
        return `${
            formatddi?.label.replace(
                formatddi.value,
                "0".repeat(formatddi.value.length)
            ) || "+00"
        } ${formatddi.mask}`;
    }

    get whatsappNumberFormated() {
        if (!this?.props?.whatsapp) return "";
        return StringUtils.formatPhoneNumber(this.phone);
    }

    getConsentWhatsapp() {
        const statusConsent = {
            PENDING: "Aguardando resposta",
            APPROVED: "Deseja receber",
            REJECTED: "Não deseja receber",
            SPAM: "Whatsapp com restrição",
            DEFAULT: "-"
        };

        return statusConsent[this.props?.consentWhatsapp?.status || "DEFAULT"];
    }
}
